import React, { Dispatch, useEffect, useState } from 'react';

import { PaperPlanMetadata } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import Alert from '@amzn/meridian/alert';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Toggle from '@amzn/meridian/toggle';

import { isEmpty } from 'lodash';
import { ROUTES } from 'src/constants/routes';
import { IPrimeAMFRateCardValidationAction } from 'src/types/IPrimeAMFRateCardValidationAction';
import { IPrimeAMFRateCardValuesAction } from 'src/types/IPrimeAMFRateCardValuesAction';
import { IPrimeAMFRateCardValues } from 'src/types/IRateCard';

import { IPrimeAMFRateCardErrors } from '../../rateCardValidationReducer';
import { AddCustomerType } from '../AddCustomerType';

interface IAddMonthlyActiveUser {
    rateCardValues: IPrimeAMFRateCardValues;
    dispatchRateCardValues: Dispatch<IPrimeAMFRateCardValuesAction>;
    rateCardErrors: IPrimeAMFRateCardErrors;
    dispatchRateCardErrors: Dispatch<IPrimeAMFRateCardValidationAction>;
    customerTypes: PaperPlanMetadata[];
}

export const AddMonthlyActiveUser: React.FC<IAddMonthlyActiveUser> = ({
    rateCardValues,
    dispatchRateCardValues,
    rateCardErrors,
    dispatchRateCardErrors,
    customerTypes
}) => {
    const [isToggled, setIsToggled] = useState(
        !isEmpty(rateCardValues.primeContractTerms?.monthlyActiveUser?.customerType)
    );
    const errorMessage = rateCardErrors.primeContractTerms.monthlyActiveUser.model;

    // Validate on rate card change
    useEffect(() => {
        dispatchRateCardErrors({
            type: 'validate_monthly_active_user',
            rateCardValues,
            isToggled
        });
    }, [rateCardValues.primeContractTerms]);

    const handleToggle = (): void => {
        if (isToggled) {
            dispatchRateCardValues({ type: 'reset_monthly_active_user' });
        } else {
            dispatchRateCardErrors({
                type: 'validate_is_next_disabled',
                rateCardValues,
                stepId: ROUTES.RATE_CARDS.STEP.CONTRACT_TERMS
            });
        }

        setIsToggled((prevIsToggled) => !prevIsToggled);
    };

    return (
        <Column>
            <Row alignmentHorizontal="justify">
                <Text type="h500">Monthly active user model</Text>
                <Toggle checked={isToggled} onChange={handleToggle} />
            </Row>
            {isToggled && (
                <>
                    {!isEmpty(errorMessage) && (
                        <Alert type="error" size="medium">
                            {errorMessage}
                        </Alert>
                    )}
                    <AddCustomerType
                        rateCardValues={rateCardValues}
                        dispatchRateCardValues={dispatchRateCardValues}
                        rateCardErrors={rateCardErrors}
                        dispatchRateCardErrors={dispatchRateCardErrors}
                        customerTypes={customerTypes}
                        isMAU={true}
                    />
                </>
            )}
        </Column>
    );
};
